<template>
	<div @click="$router.back(1)" class="navBack">
		<i class="el-icon-back"></i>
		<p>{{title}}</p>
		<div style="width: 30px;height: 40px;"></div>
	</div>
</template>

<script>
	export default{
		props:['title']
	}
</script>

<style scoped>
	@media screen and (max-width: 750px) {
		.el-icon-back{
			font-size: 28px;
		}
		.navBack{
			height: 50px;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			font-size: 20px;
			box-sizing: border-box;
			background-color: #fff;
			border-bottom: 1px solid #f2f2f2;
		}
	}
	@media screen and (min-width: 750px) {
		.navBack{
			display: none;
		}
	}
</style>